<!------------------------------------------------------------------------------
  Copyright (c) 2019. Keni Williams <kenneth.williams@estuk.co.uk>

  This file CheckoutSuccessful.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  CheckoutSuccessful.vue can not be copied and/or distributed
  without the express permission of Keni Williams <kenneth.williams@estuk.co.uk>
  ----------------------------------------------------------------------------->

<template>
    <div v-if="show">
        <div class="d-flex justify-content-center align-items-center bg-success p-3 z-depth-3"><i
                class="material-icons done-icon mr-2">done</i>
            <div class="p-2">
                <h3 class="p-0">Payment successful</h3>
                <span v-if="user_auth">
                    Thank you for your ticket purchase. Login to view your purchase
                    <a :href="route" class="btn btn-primary">
                        My account
                    </a>
                </span>
                <span v-else>
                    Thank you for your ticket purchase. An email has been sent to you with instructions
                    <a :href="route" class="btn btn-primary">
                        Login
                    </a>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CheckoutSuccessful",
        props: {
            show: {
                type: Boolean,
                default: false
            },
            user_email:{
                type: String,
                default: null
            },
            user_auth: {
                type: Boolean,
                default: false
            },
        },
        data(){
            return {
                route:''
            }
        },
        mounted() {
            if(this.user_auth){
                this.route ='/account/?email=' + this.user_email;

            }else{
                this.route ='/login/?email=' + this.user_email;
            }
        }
    }
</script>

<style scoped>
    .done-icon{
        font-size: 4rem;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/checkout/CheckoutSuccessful.vue